var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.50008L16.4571 5.79297L17.1642 6.50008L16.4571 7.20719L15.75 6.50008ZM1.25 7.50008C0.697715 7.50008 0.25 7.05237 0.25 6.50008C0.25 5.9478 0.697715 5.50008 1.25 5.50008V7.50008ZM11.6238 0.959641L16.4571 5.79297L15.0429 7.20719L10.2096 2.37385L11.6238 0.959641ZM16.4571 7.20719L11.6238 12.0405L10.2096 10.6263L15.0429 5.79297L16.4571 7.20719ZM15.75 7.50008H1.25V5.50008H15.75V7.50008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.2a3111ac8b82fdcb6a7c6e5123c4ce19.svg";
export { ForwardRef as ReactComponent };